import * as React from 'react'
import * as Yup from 'yup'
import { Formik, Form } from 'formik'
import { styled } from '@mui/material/styles'
import { Grid, Box, Button, Stack } from '@mui/material'
import { Typography as MIUTypography } from '@mui/material'
import { InputAdornment } from '@mui/material'
import { approveUserAccount } from '../../services'
import { schema } from '../../utils/schemaValidation'
import { getMeasuringGroup, isUserVerify, getUserById } from '../../services'
import { useParams } from 'react-router-dom'

import { CandlestickChart, AccountCircle } from '@mui/icons-material'
import AlertCustom from '../../components/Alerts'
import Textfield from '../../components/FormsUI/Textfield'
import Selectfield from '../../components/FormsUI/Select'
import _ from 'lodash'

const BUTTON_COLOR = 'var(--color-green-light)'
const TEXT_BUTTON_COLOR = '#EDEEFF'

const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: '1.125em',
  fontWeight: props.istitle ? 700 : 450,
  lineHeight: props.istitle ? '24px' : '24px',
  color: props.istitle ? '#1B1C37' : '#6A6A6A',
  textAlign: 'center',
}))

const ButtonCustom = styled(Button)({
  height: '40px',
  backgroundColor: BUTTON_COLOR,
  textTransform: 'capitalize',
  fontFamily: 'Avenir Next',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '22px',
  color: TEXT_BUTTON_COLOR,
  fontSize: '16px',
  '&:hover': {
    backgroundColor: '#0fa73d',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: BUTTON_COLOR,
    borderColor: BUTTON_COLOR,
  },
})

const styleStack = {
  justifyContent: 'center',
  direction: 'column',
  alignItems: 'center',
  py: 2,
  px: '8vw',
  height: '100%',
  spacing: 2,
  width: '100%',
}

const boxStyle = {
  minWidth: '300px',
  maxWidth: '500px',
  bgcolor: 'background.paper',
  boxShadow: 14,
  pb: '50px',
  px: '25px',
  pt: 6,
  textAlign: 'center',
  borderRadius: '14px',
}

const FORM_VALIDATION = Yup.object().shape({
  ...schema.MEASURING_GROUP,
})

const ValidationAccount = () => {
  const alertRef = React.useRef()
  const { token } = useParams()

  const [options, setOptions] = React.useState(null)
  const [validToken, setValidToken] = React.useState(true)
  const [isAccountEnabled, setAccountEnabled] = React.useState(false)
  const [isStored, setIsStored] = React.useState(null)
  const [INITIAL_FORM_STATE, SET_INITIAL_FORM_STATE] = React.useState(null)

  const formatToken = token ? _.split(token, '=')?.[1] : ''
  const TOKEN = 'Bearer ' + formatToken

  const handleAuthorizeAccount = async ({ measuring_group }) => {
    let resultSave = { stored: true }
    const idGrupoMedicion = measuring_group === '-1' ? null : measuring_group
    const response = await approveUserAccount({ idGrupoMedicion }, TOKEN)
    if (!response?.update) {
      resultSave = { stored: false, message: response?.message }
    }
    return resultSave
  }

  React.useEffect(() => {
    isUserVerify(TOKEN)
      .then(data => {
        const { user } = data
        const { userIdCheck } = user || {}
        if (Boolean(userIdCheck)) {
          getUserById(userIdCheck, TOKEN)
            .then(res => {
              if (res?.auth && !Boolean(res.user.habilitado.data[0]))
                SET_INITIAL_FORM_STATE({
                  username: res.user.nombre,
                  lastname: res.user.apellido,
                  email: res.user.email,
                  measuring_group: res.user.idGrupoMedicion ?? '-1',
                })
              else setAccountEnabled(true)
            })
            .catch(err => console.log('Error: ', err))
        } else setValidToken(false)
      })
      .catch(err => console.log('Error: ', err))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    if (options) return
    getMeasuringGroup()
      .then(workGroup => {
        let objOption = { '-1': 'No asignado' }
        if (workGroup?.res) {
          _.forEach(workGroup.res, res => {
            if (!Boolean(res.habilitado.data[0])) return
            let objNew = {}
            objNew[res.id_gm] = res.nombre
            objOption = { ...objOption, ...objNew }
          })
        }
        setOptions(objOption)
      })
      .catch(err => console.log('Error :>> ', err.message))
  }, [options])

  return (
    <Box>
      {!Boolean(isStored?.stored) && INITIAL_FORM_STATE && !isAccountEnabled ? (
        <Stack {...styleStack}>
          <Box sx={boxStyle}>
            <Formik
              initialValues={{ ...INITIAL_FORM_STATE }}
              validationSchema={FORM_VALIDATION}
              onSubmit={async values => {
                const itsStored = await handleAuthorizeAccount(values)
                setIsStored(itsStored)
                alertRef.current?.openAlert(true)
              }}>
              <Form>
                <Grid container spacing={2} sx={{ pt: 0, width: '100%', ml: 0 }}>
                  <Grid item xs={6} style={{ paddingLeft: 0, paddingRight: 4 }}>
                    <Textfield
                      name="username"
                      label="Nombre"
                      placeholder="Ingrese su nombre"
                      variant="standard"
                      disabled={true}
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={6} style={{ paddingLeft: 4 }}>
                    <Textfield
                      name="lastname"
                      label="Apellido"
                      placeholder="Ingrese su apellido"
                      variant="standard"
                      disabled={true}
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ paddingLeft: 0 }}>
                    <Textfield
                      name="email"
                      label="Ingrese su correo electrónico"
                      variant="standard"
                      disabled={true}
                      InputProps={{
                        readOnly: true,
                        startAdornment: (
                          <InputAdornment position="start">
                            <AccountCircle />
                          </InputAdornment>
                        ),
                      }}
                      placeholder="user@example.com"
                    />
                  </Grid>
                  {options && (
                    <Grid item xs={6} style={{ paddingLeft: 0, paddingRight: 4 }}>
                      <Selectfield
                        name="measuring_group"
                        label="Grupo de medición"
                        options={options}
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <CandlestickChart />
                            </InputAdornment>
                          ),
                        }}
                        placeholder="Vuelve a ingresar la contraseña"
                      />
                    </Grid>
                  )}
                  <Grid item xs={options ? 6 : 12} style={{ paddingLeft: 4 }}>
                    <ButtonCustom variant="contained" fullWidth type="submit">
                      HABILITAR USUARIO
                    </ButtonCustom>
                  </Grid>
                </Grid>
              </Form>
            </Formik>
          </Box>
        </Stack>
      ) : (
        <Box pt={'5vh'}>
          <Typography sx={{ color: '#000', fontWeight: 600 }}>
            ¡La cuenta perteneciente a este enlace se encuentra habilitada!
          </Typography>
        </Box>
      )}

      {!isAccountEnabled && !isStored?.stored && validToken && (
        <Box pt={'5vh'}>
          <Typography sx={{ color: '#000', fontWeight: 500 }}>
            Este enlace es válido. Puede actualizar el grupo al que pertecene este
            usuario. Si desea modificar otros datos del usuario hágalo en la sección de
            administración de usuarios de la aplicación web.
          </Typography>
        </Box>
      )}

      {!isAccountEnabled && !isStored?.stored && !validToken && (
        <Box pt={'5vh'}>
          <Typography sx={{ color: '#000', fontWeight: 500 }}>
            Este enlace ya no es válido. Es posible que haya caducado el token actual o no
            sea el correcto. Para gestionar cuentas de usuario hágalo en la sección de la
            aplicación web:
          </Typography>
          <Typography sx={{ color: '#000', fontWeight: 500, pt: 2 }}>
            Administrar Registros / Registros globales / Usuarios
          </Typography>
        </Box>
      )}

      <AlertCustom
        ref={alertRef}
        severity={!Boolean(isStored?.stored) ? 'warning' : 'success'}>
        {!Boolean(isStored?.stored) ? isStored?.message : 'Cuenta de usuario activada!'}
      </AlertCustom>
    </Box>
  )
}

export default ValidationAccount
